import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  modal: {
    minHeight: 300
  }
})

export default useStyles
